module.exports = __webpack_public_path__ + "static/media/lowresportfolio-24.e6bf9179.jpg";